import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v1/colors";
import { useCompany } from "#modules/company/view/useCompany";
import { HomeDropZone } from "#modules/quoteRequestLines/HomeDropZone";
import { useValidFilesTypes } from "#modules/quoteRequestLines/useValidFileTypes";
import { useCreatePartToSearch } from "#modules/similarPart/view/useCreatePartToSearch";
import { useAnalytics, AnalyticsEvent } from "#shared/useAnalytics";
import { Stack } from "#shared/view/components/Stack";
import { UPLOAD_CONFIG } from "shared";

import classes from "./SearchSimilarPartDropzone.module.css";

export const SearchSimilarPart = () => {
  const { t } = useTranslation();
  const analytics = useAnalytics();
  const { company } = useCompany();
  const { isPending, uploadFile, progress } = useCreatePartToSearch();

  const { validExtensions, accept } = useValidFilesTypes("search");

  return (
    <Stack gap="xs" className={`${classes.search!} ${classes.panel!}`}>
      <HomeDropZone
        title={t("similarPart.dropzone.title")}
        loading={isPending && !progress}
        multiple={false}
        illustration="/images/search.png"
        onDrop={async (files) => {
          analytics.capture(AnalyticsEvent.UserDropFile, { workflow: "search" });
          analytics.capture(AnalyticsEvent.SimilarPartSearchStarted, {
            file_count: files.length,
            company_name: company?.name,
          });
          await uploadFile(files);
        }}
        classes={classes}
        uploadProgress={progress}
        progressBarColor={colors.blue[5]}
        validFileTypeText={t("similarPart.dropzone.search")}
        validExtensions={validExtensions}
        accept={accept}
        maxSize={UPLOAD_CONFIG.PART.maxFileSize}
      />
    </Stack>
  );
};
